import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Segment, Loader, Header, Icon } from 'semantic-ui-react'

import AuthActions from 'Redux/AuthRedux'

import Alert from 'Components/Alert'

class Profile extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      name: this.props.userData.name || ''
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.userData.name !== prevProps.userData.name) {
      this.setState({name: this.props.userData.name})
    }
  }

  onSaveSettings = () => {
    this.props.profileUpdateRequest({
      name: this.state.name
    })
  }

  onChange = event => {
    const { name, value } = event.target
    this.setState({[name]: value})
  }

  render () {
    return (
        <Segment>
          <Alert color='red' messages={this.props.error} />
          <Form>
            <Header as='h2'>
            <Icon name='user' color='grey' />
              <Header.Content>
                Edit Profile
              </Header.Content>
            </Header>
            <Loader active={this.props.fetching} />
            <Form.Field>
              <label>Name</label>
              <input
                type='text'
                name='name'
                placeholder='Name'
                value={this.state.name}
                onChange={this.onChange}
              />
            </Form.Field>

            <Button
              primary
              type='submit'
              onClick={this.onSaveSettings}>Submit</Button>
          </Form>
        </Segment>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  fetching: state.auth.updateFetching,
  error: state.auth.updateError
})

const mapDispatchToProps = (dispatch) => ({
  profileUpdateRequest: (params) =>
    dispatch(AuthActions.profileUpdateRequest(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)



// WEBPACK FOOTER //
// ./src/Components/Profile.js